import { useEffect } from 'react';

import { useHiddenFormContext } from '../../contexts';
import { ActionTypes } from '../../models';

interface UseProviderIframeProps {
  actionType: ActionTypes;
}

export const useProviderIframe = ({ actionType }: UseProviderIframeProps) => {
  const { submitForm } = useHiddenFormContext();

  useEffect(() => {
    if (actionType === ActionTypes.FORM_SUBMIT) {
      submitForm();
    }
  }, [actionType, submitForm]);
};
